import React from 'react';
import PropTypes from 'prop-types';
import './Nav.css';
import { getLocationName } from '../../utils/utils';
import { translate } from '../../utils/translations';

const Nav = props => {
    const {
        alternativeTitle,
        locationCode,
        cities,
        alternativeMenu,
        language,
        linkAlternativeMenu,
    } = props;

    const menu = alternativeMenu ? (
        <ul>
            <li>
                <a href={linkAlternativeMenu}>{alternativeMenu}</a>
            </li>
        </ul>
    ) : (
        <ul>
            <li>
                <a href={translate(language, 'nav_prediction_url')}>
                    {translate(language, 'nav_prediction')}
                </a>
            </li>
            <li>
                <a href={translate(language, 'nav_radar_url')}>
                    {translate(language, 'nav_radar')}
                </a>
            </li>
            <li>
                <a href={translate(language, 'nav_data_url')}>
                    {translate(language, 'nav_data')}
                </a>
            </li>
        </ul>
    );

    const { hour } = props;
    return (
        <div className="mc-widget-nav">
            <div style={{ display: 'inline-block' }}>
                <div className="mc-widget-nav__date">
                    {props.widgetDate}
                    {hour ? (
                        <div className="nav__hour">
                            <span>|</span>
                            {hour}
                        </div>
                    ) : null}
                </div>
                <div className="mc-widget-nav__place">
                    {alternativeTitle
                        ? alternativeTitle
                        : locationCode && cities
                            ? getLocationName(locationCode, cities)
                            : ''}
                </div>
            </div>
            <div className="mc-widget-nav__nav">{menu}</div>
        </div>
    );
};

Nav.propTypes = {
    alternativeMenu: PropTypes.string,
    alternativeTitle: PropTypes.string,
    cities: PropTypes.arrayOf(
        PropTypes.shape({
            codi: PropTypes.string,
            comarca: PropTypes.object,
            coordenades: PropTypes.object,
            nom: PropTypes.string,
            slug: PropTypes.string,
        })
    ),
    language: PropTypes.string,
    linkAlternativeMenu: PropTypes.string,
    locationCode: PropTypes.string,
    widgetDate: PropTypes.string,
};

export default Nav;



// WEBPACK FOOTER //
// ./src/partials/Nav/Nav.js